import { isWeb, YStack } from "tamagui";
import { useInteractiveElement } from "../interactive/useInteractiveElement";
import { SelectionPillFrame, SelectionPillLabel } from "../SelectionPill";
import { Caption } from "../Typography";
export type FilterChipProps = {
  label: string;
  selected: boolean;
  onPress: () => void;
  count?: number;
  disabled?: boolean;
};
export const FilterChip = ({
  label,
  selected,
  onPress,
  count = 0,
  disabled = false
}: FilterChipProps) => {
  const {
    interactiveProps,
    renderTag
  } = useInteractiveElement({
    kind: "button",
    onPress,
    disabled
  });
  return <SelectionPillFrame {...interactiveProps} render={renderTag} cursor={disabled ? "not-allowed" : "pointer"} fill={selected ? "neutral" : "none"} aria-pressed={selected} aria-label={count > 0 ? `${label} ${count}` : label}
  // React Native maps neither the button tag nor aria-pressed.
  {...isWeb ? {} : {
    accessibilityRole: "button",
    accessibilityState: {
      selected,
      disabled
    }
  }} data-sentry-element="SelectionPillFrame" data-sentry-component="FilterChip" data-sentry-source-file="FilterChip.tsx">
      <SelectionPillLabel look={selected ? "neutralOn" : "off"} disabled={disabled} data-sentry-element="SelectionPillLabel" data-sentry-source-file="FilterChip.tsx">
        {label}
      </SelectionPillLabel>
      {count > 0 ? <YStack paddingHorizontal="$sp0.5" borderRadius="$brFull" backgroundColor="$bgNegativeStrong">
          <Caption color="$textInverse">{count}</Caption>
        </YStack> : null}
    </SelectionPillFrame>;
};